import React, { Fragment } from "react";

import Grid from "@mui/material/Grid";
import UpdatePasswordComponent from "../component/app/login/UpdatePassword.component";

const ForgotPasswordPage = () => {
  return (
    <Fragment>
      <Grid container sx={{ height: "100vh", backgroundColor: "#fafffc" }}>
        <Grid md={4} />
        <Grid
          item
          md={4}
          xs={12}
          sx={{
            height: "100vh",
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <UpdatePasswordComponent />
        </Grid>
        <Grid md={4} />
      </Grid>
    </Fragment>
  );
};

export default ForgotPasswordPage;
